module.exports = __webpack_public_path__ + "media/images/support-27e14dcf34d145acf86ad185a8c4d538.png";